import "./App.css";
import { Navigate, Outlet, RouterProvider, createBrowserRouter, useMatches } from "react-router-dom";
import { Suspense, useEffect } from "react";
import LoadingBackdrop from "../Components/LoadingBackdrop/LoadingBackdrop";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { theme } from "../Resources/Design/theme";
import { HelmetProvider } from "react-helmet-async";
import ErrorRouteLogger from "../Pages/CZ/ErrorPage/ErrorRouteLogger";
import { getRoutes, isAdmin, LanguageRedirect } from "../Localization/routesLocalized";
import { PublicProviders, ResultProviders, DefaultProviders, AdminProviders } from '../Providers/Providers';
import BaseFooter from "../Components/Public/Footer/BaseFooter";
import Helmet from "../Components/Helmet";
import ScrollUp from "../Components/ScrollUp";
import LanguageLayout from "../Localization/LanguageLayout";
import AppBar from "../Components/Public/AppBar/AppBar";
import '../Localization/i18n';

function Providers({ children }) {
  const matches = useMatches();
  const currentRoute = matches[matches.length - 1];

  const routeProps = currentRoute?.handle || {};

  if (routeProps?.admin) {
    return <AdminProviders>
      {children}
    </AdminProviders>
  }

  if (routeProps?.default) {
    return <DefaultProviders>
      {children}
    </DefaultProviders>
  }

  if (routeProps?.result) {
    return <ResultProviders>
      {children}
    </ResultProviders>
  }
  return <PublicProviders>
    {children}
  </PublicProviders>

}

function RouteControl({ ...props }) {
  const matches = useMatches();
  const currentRoute = matches[matches.length - 1];

  const routeProps = currentRoute?.handle || {};
  const {
    hideNavbar = false,
    hideFooter = false,
    backgroundColor = '#ffffff',
    appbarColors = undefined,
    langOnlySwitch = false,
  } = routeProps;


  return (
    <ErrorRouteLogger>
      <LanguageLayout>
        <Helmet>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <ScrollUp />
            <Providers>
              <div className="App" style={{ minWidth: '320px', backgroundColor }}>
                {!hideNavbar && !isAdmin() && <AppBar colors={appbarColors} langOnlySwitch={langOnlySwitch} />}
                <main style={{ minHeight: '100vh' }}>
                  <Outlet context={props} />
                </main>
                {!hideFooter && <BaseFooter langOnlySwitch={langOnlySwitch} />}
              </div>
            </Providers>
          </ThemeProvider>
        </Helmet>
      </LanguageLayout>
    </ErrorRouteLogger>
  );
}

const router = createBrowserRouter([
  {
    path: "/:lng/*",
    element: <RouteControl />,
    errorElement: <ErrorRouteLogger />,
    children: getRoutes(),
  },
  {
    path: "/",
    element: <LanguageRedirect />,
    errorElement: <ErrorRouteLogger />,
  },
  {
    path: "*",
    element: <LanguageRedirect />,
    errorElement: <ErrorRouteLogger />,
  }
]);

function App() {

  return (
    <Suspense fallback={<LoadingBackdrop open={true} />}>
      <HelmetProvider>
        <RouterProvider router={router} />
      </HelmetProvider>
    </Suspense>

  );
}

export default App;
